import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { PageHero } from "@/components/PageHero";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { CtaBanner } from "@/components/CtaBanner";
import { BrandsMarquee } from "@/components/BrandsMarquee";

export default function Services() {
  return (
    <>
      <PageHero
        label="Our Services"
        title="Complete electrical, climate & hot water solutions"
        subtitle="From split systems to whole-home ducted comfort, heat pump hot water and professional electrical work — one qualified team for it all."
        crumbs={[{ label: "Services" }]}
      />

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <SectionLabel>What We Offer</SectionLabel>
          </Reveal>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Wrench;
              return (
                <Reveal key={s.slug} delay={(i % 3) * 0.08}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`services-card-${s.slug}`}
                    className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition-shadow duration-300 hover:shadow-xl"
                  >
                    <div className="relative aspect-[16/10] overflow-hidden">
                      <img src={s.image} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      <div className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl bg-white/95 backdrop-blur">
                        <Icon className="h-5 w-5 text-brand-electric" strokeWidth={1.75} />
                      </div>
                    </div>
                    <div className="flex flex-1 flex-col p-7">
                      <h3 className="font-display text-xl font-semibold text-brand-blue">{s.title}</h3>
                      <p className="mt-2 flex-1 text-[15px] leading-relaxed text-slate-600">{s.short}</p>
                      <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-brand-electric">
                        Learn more <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-[#FAFAFA] py-16 border-y border-slate-100">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal><p className="text-center text-sm uppercase tracking-[0.2em] text-[#486581] font-semibold">Brands we work with</p></Reveal>
        </div>
        <div className="mt-10"><BrandsMarquee /></div>
      </section>

      <CtaBanner />
    </>
  );
}
